const commonConfig = {
  env: process.env.NODE_ENV || 'development',
  api: import.meta.env.VITE_API,
  appVersion: import.meta.env.VITE_VERSION,
  google: {
    clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
    redirectUri: import.meta.env.VITE_GOOGLE_REDIRECT_URI,
  },
  stripe: {
    publicApiKey: import.meta.env.VITE_STRIPE_PUBLIC_API_KEY,
    // redirectUrl: import.meta.env.VITE_STRIPE_REDIRECT_URL || 'http://localhost:5000/stripe',
  },
  extendTrial: {
    email: import.meta.env.VITE_EMAIL_EXTEND_TRIAL || '',
  },
  sentry: {
    dns: import.meta.env.VITE_SENTRY_DNS,
    enabled: import.meta.env.VITE_SENTRY_ENABLED,
  },
  gtag: {
    enabled: import.meta.env.VITE_ENABLED_G_TAG,
    id: import.meta.env.VITE_G_TAG_ID,
    sendTo: import.meta.env.VITE_G_TAG_SEND_TO,
  },
  s3: {
    generaBucket: import.meta.env.VITE_GENERAL_BUCKET,
  },
  paypal: {
    clientId: import.meta.env.VITE_PAYPAL_CLIENT_ID,
    bnCode: import.meta.env.VITE_PAYPAL_BN_CODE_ID,
    appUrl: import.meta.env.VITE_PAYPAL_APP_URL,
  },
  exchangeRate: {
    apiKey: import.meta.env.VITE_EXCHANGE_RATE_API_KEY,
  },
  logByUser: {
    userIds: import.meta.env.VITE_LOG_USER_IDS ? import.meta.env.VITE_LOG_USER_IDS.split(',') : [],
  },
};

export default {
  ...commonConfig,
};
